import * as React from "react";
import "./Privacy.css";
import { Helmet } from "react-helmet-async";

export default function PrivacyPolicy() {
  <Helmet>
    <title>Ponvel Exim’s Privacy Policy. – Ponvel Exim</title>
    <meta name="description" content="View Ponvel Exim’s Privacy Policy" />
    <meta name="keywords" content="Ponvel Exim Privacy Policy," />
    <link rel="canonical" href="https://ponvelexim.com/privacy-policy" />

    {/* Open Graph */}
    <meta property="og:site_name" content="Ponvel Exim" />
    <meta property="og:locale" content="en_IN" />
    <meta property="og:title" content="Privacy Policy. – Ponvel Exim" />
    <meta
      property="og:description"
      content="Check Ponvel Exim’s privacy policy."
    />
    <meta property="og:image" content="https://ponvelexim.com/logo192.png" />
    <meta property="og:url" content="https://ponvelexim.com/privacy-policy" />
    <meta property="og:type" content="website" />

    {/* Twitter */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Privacy Policy – Ponvel Exim" />
    <meta
      name="twitter:description"
      content="Check Ponvel Exim’s privacy policy."
    />
    <meta name="twitter:image" content="https://ponvelexim.com/logo192.png" />
  </Helmet>;

  return (
    <>
      <div className="Privacy-container">
        <h2>Privacy Policy</h2>
        <div>
          Welcome to Ponvel Exim. Your privacy is important to us. This Privacy
          Policy explains how we collect, use, disclose, and protect the
          personal information you provide when you visit and interact with our
          website https://ponvelexim.com/. By accessing or using our Website,
          you agree to the practices described in this policy.
        </div>
        <div>
          <h3>Information We Collect</h3>
          <p>
            a) Personal Information We may collect personal information that you
            voluntarily provide when you: Use contact forms Sign up for
            newsletters Request a quote, service, or support Communicate with us
            via email or phone Examples of personal information we collect: Full
            name, Email, address, Phone number, Company name, Business address
            Other information you choose to provide.
          </p>{" "}
          <p>
            b) Non-Personal Information We automatically collect
            non-identifiable data when you visit our
          </p>
          Website, such as:
          <li>IP address</li>
          <li>Browser type</li>
          <li>Device information</li>
          <li>Pages visited</li>
          <li>Date and time of visit</li>
          This helps us improve user experience and monitor website performance.
          <p>
            c) Cookies and Tracking We may use cookies and similar tracking
            technologies to personalize your experience, remember preferences,
            and analyse site usage. Cookies can be managed through your browser
            settings.
          </p>
          <h3> How We Use Your Information</h3>
          We use your information to:
          <li>Respond to your inquiries and provide customer support</li>
          <li>
            Send updates, newsletters, or promotional messages (only if you
            opt-in)
          </li>
          <li>Provide and improve our services</li>
          <li>Analyse Website usage and improve our content</li>
          <li>Comply with legal requirements and protect our rights</li>
          Your information will not be sold, rented, or shared with third
          parties for their marketing purposes without your consent.
          prandrexim.com
          <h3> Sharing Your Information</h3>
          We may share your information in the following limited situations:
          <li>
            Service Providers: Trusted partners who help us operate our Website
            or perform business functions
          </li>
          <li>
            Legal Requirements: When required by law, regulation, or legal
            process
          </li>
          <li>
            Business Transfers: If the company undergoes a merger, acquisition,
            or asset sale
          </li>
          We require these parties to protect your data and only use it to
          fulfil their roles.
          <h3> Data Security</h3>
          We implement reasonable technical and administrative measures to
          safeguard your information against unauthorized access, misuse, loss,
          or alteration. However, no system is completely secure.
          <h3> Your Rights</h3>
          <li>
            Depending on applicable laws, you may have rights regarding your
            personal data:
            <li>Access or request a copy of your data</li>
            <li>Correct inaccurate or incomplete information</li>
            <li>Request deletion in certain circumstances</li>
            <li></li>Opt out of marketing communications
          </li>
          To exercise these rights, please contact us (details below).
          <h3> Third-Party Links</h3>
          Our Website may contain links to third-party sites, tools, or
          services. We do not control the privacy practices of those sites and
          recommend you review their privacy policies separately.
          <h3> Children’s Privacy</h3>
          Our Website is not directed to children under 18, and we do not
          knowingly collect personal information from minors. If we discover we
          have inadvertently collected such information, we will take steps to
          delete it.
          <h3> Changes to This Policy</h3>
          We may update this Privacy Policy periodically. The revised version
          will be posted here with an updated effective date. Please review this
          page regularly.
          <h3> Contact Us</h3>
          If you have questions or concerns about this Privacy Policy, or to
          exercise your rights, contact us:
          <li>Email: support@ponvelexim.com.</li>
          <li>
            Address: 1/2, Ramasamy Gounder Layout, 60 Feet Road,Perichipalayam
            South, Tirupur - 641 604.
          </li>
          <li>Phone: +91 8056390034.</li>
        </div>
      </div>
    </>
  );
}
